module.exports = __webpack_public_path__ + "static/media/Mynorca_example.ffdfd06a.PNG";